
import React from "react";
import { Box, TextField, Button, CircularProgress } from "@mui/material";

export default function SearchForm({ query, onQueryChange, onSubmit, loading }) {
  // restante de caracteres (opcional para feedback visual)
  const remaining = Math.max(10 - (query?.length || 0), 0);

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      sx={{
        display: "flex",
        gap: 1.5,
        width: "100%",         // preenche a página
        maxWidth: "100%",       // sem limite
        alignItems: "center",
      }}
    >
      <TextField
  id="search"
  label="Search"
  placeholder="Type your search"
  value={query}
  onChange={(e) => onQueryChange(e.target.value.slice(0, 10))}
  size="small"
  inputProps={{ maxLength: 10 }}
  sx={{
    width: "50%",           // metade da largura do container pai
    "& .MuiInputBase-input": {
      fontSize: "0.9rem",
    },
  }}
  autoFocus
/>


      <Button
        type="submit"
        disabled={loading}
        variant="contained"
        sx={{
          alignSelf: "stretch",        // altura igual ao campo
          minWidth: 120,
          borderRadius: "8px",
          fontSize: "14px",
          padding: "6px 14px",
          color: "#fff",
          background:
            "linear-gradient(90deg, #7b1fa2 0%, #d81b60 100%)", // Roxo -> Magenta (diferente do azul)
          "&:hover": {
            background:
              "linear-gradient(90deg, #6a1b9a 0%, #c2185b 100%)",
          },
        }}
      >
        {loading ? (
          <>
            <CircularProgress
              size={16}
              sx={{ color: "white", mr: 1 }}
            />
            Searching...
          </>
        ) : (
          "Search"
        )}
      </Button>
    </Box>
  );
}
